import { Link } from 'react-router-dom';

interface FilmCardProps {
  id: number;
  title: string;
  slug: string;
  coverImage: string;
  category: string;
  year: number;
  rating: number;
  duration: string;
  quality: string;
  tags: string[];
}

const categoryNameMap: Record<string, string> = {
  featured: '精选推荐',
  classic: '经典系列',
  latest: '最新作品',
  'top-rated': '高分好评',
  exclusive: '独家珍藏',
};

export default function FilmCard({
  id,
  title,
  slug,
  coverImage,
  category,
  year,
  rating,
  duration,
  quality,
  tags,
}: FilmCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={coverImage}
          alt={title}
          title={`${title} - 北条麻妃电影作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
            {quality}
          </span>
        </div>
        <div className="absolute top-3 right-3">
          <span className="inline-flex items-center gap-1 bg-background-950/70 text-background-50 text-xs font-medium px-2 py-1 rounded-full whitespace-nowrap">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
            {rating}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/80 to-transparent h-24"></div>
        <div className="absolute bottom-3 left-3 right-3">
          <span className="text-background-50/80 text-xs whitespace-nowrap">
            {categoryNameMap[category] || category}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-foreground-900 font-heading font-semibold text-base group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
          {title}
        </h3>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-600">
          <span className="whitespace-nowrap">{year}</span>
          <span className="text-foreground-400">|</span>
          <span className="whitespace-nowrap">{duration}</span>
        </div>
        <div className="flex flex-wrap gap-1.5 mt-3">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="inline-block bg-secondary-100 text-secondary-700 text-xs px-2 py-0.5 rounded whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}